<template>
  <div class="bottom-wrap w-full flex flex-row items-center gap-3 bg-white text-center">
    <div class="" @click="onShowConnectTypeClick" :class="disabled ? 'disable-click':''">
      <div class="relative">
        <div class="bt-nfc-icon-size">
          <img :src="currentSelectImage"/>
        </div>

        <div class="rb-triangle absolute right-1.5 bottom-1.5"></div>
      </div>
    </div>
    <div @click="onClick" class="bottom-back-btn flex-1" :class="disabled ? 'disable-click':''">{{text}}</div>

    <transition name="slide-fade">
      <div class="head-menu-show" v-if="showConnectType">
        <div class="menu-wrap gap-4">
          <div class="bt-nfc-icon-size" @click="onQrClicked">
            <van-image class="menu-item" :src="qrImage" />
          </div>
          <div class="bt-nfc-icon-size" @click="onNfcClicked">
            <van-image class="menu-item" :src="nfcImage" />
          </div>
        </div>
        <div class="triangle">
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
export default {
  name: "CustomizationBottomOperateQrNfc",

  props: {
    disabled: {
      type: Boolean,
      default: false
    },
    text: {
      type: String,
      default: "Enter"
    },
    showTriangle: {
      type: Boolean,
      default: false
    },
    showEdit: {
      type: Boolean,
      default: false
    },
    funcType: {
      type:Number,
      default: 1 //1是扫码 2是NFC
    }
  },

  data() {
    return {
      showConnectType: false,
      nfcImage: require("@/assets/icons/v2/icon_fn_nfc.svg"),
      qrImage: require("@/assets/icons/v2/icon_fn_scan_qr.svg"),
    };
  },
  methods: {
    onShowConnectTypeClick() {
      if (!this.showConnectType) {
        this.showConnectType = true;
      }
    },


    click_allFunction_side(e) {
      if (e.target.className !== "bt-nfc-icon-size" && e.target.className !== "van-image__img") {
        this.showConnectType = false;
        e.stopPropagation();
      }
    },
    onClick() {
      this.$emit("onNext");
    },
    onQrClicked() {
      this.$emit('onFuncTypeChange',1)
      this.showConnectType = false;
    },
    onNfcClicked() {
      this.$emit('onFuncTypeChange',2)
      this.showConnectType = false;
    }
  },
  computed: {
    currentSelectImage() {
      if (this.funcType === 1) {
        return this.qrImage
      }
      return this.nfcImage
    }
  },
  watch: {
    showConnectType(newVal, oldVal) {
      if (newVal) {
        document.addEventListener("click", this.click_allFunction_side, true);
        document.addEventListener("scroll", this.click_allFunction_side, true);
      } else {
        if (document.removeEventListener) {
          document.removeEventListener(
              "click",
              this.click_allFunction_side,
              true
          );
          document.removeEventListener(
              "scroll",
              this.click_allFunction_side,
              true
          );
        } else if (document.detachEvent) {
          document.detachEvent("click", this.click_allFunction_side, true);
          document.detachEvent("scroll", this.click_allFunction_side, true);
        }
      }
    },
  }
};
</script>

<style scoped lang="less">
.bottom-wrap {
  font-size: 24px;
  padding: 0 16px;
  height: calc(70px + env(safe-area-inset-bottom));
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
}

.head-menu-show {
  position: absolute;
  left: 26px;
  bottom: calc(70px + env(safe-area-inset-bottom) - 8px - 24px);
  z-index: 9999;
  display: flex;
  flex-direction: column;
  transition: all 0.3s ease;


  .menu-wrap {
    box-shadow: 0 0 calc(70px + env(safe-area-inset-bottom)) 0 rgba(0, 0, 0, 0.1);
    background: white;
    display: flex;
    flex-direction: row;
    align-items: center;
    padding: 15px;
    margin: -5px 0 0 -15px;
    border-radius: 10px;

    .menu-item {
      display: flex;
      align-items: center;

      &:first-child {
        margin-top: 0
      }
    }
  }
}

.bt-nfc-icon-size {
  width: 48px;
  height: 48px;
  border-radius: 12px;
  border: 1px solid #BEBEBE;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}

.triangle {
  width: 0;
  height: 0;
  border-top: 20px solid white;
  border-right: 17px solid transparent;
  border-bottom: 20px solid transparent;
  border-left: 17px solid transparent;
  z-index: 2;
}

.rb-triangle {
  width: 0;
  height: 0;
  border-top: 6px solid transparent;
  border-right: 6px solid black;
  border-bottom: 0px solid transparent;
  border-left: 0px solid transparent;
  z-index: 2;
}

.read-write-btn {
  height: 44px;
  line-height: 44px;
}

.slide-fade-enter-active, .slide-fade-leave-active {
  transition: all 0.3s ease;
}

.slide-fade-enter, .slide-fade-leave-to /* .slide-fade-leave-active in <2.1.8 */ {
  transform: translateY(20px);
  opacity: 0;
}
</style>